import { Effect, Reducer } from 'umi';
import {
  getOverviewKeyMetrics,
  getOverviewRegion,
  getOverviewLanguage,
  getOverviewChannel,
  getOverviewKeyword,
  getOverviewTopic,
  getOverviewCompetitor,
  getOverviewGameStore,
  getOverviewCountry,
  getOverviewDauRevDls,
  getOverviewLifetimePcConsole,
  getOverviewTimeline,
  getOverviewTopicTimeline,
  getOverviewKeywordTimeline,
  getOverviewVersionTimeline,
} from '@/pages/opinion/services/performance';
import {
  keyMetricsListType,
  overviewOriginType,
} from '../../types/performance';
import { transformGlobal } from '../../utils';
import { getRealtimeLanguage, getRealtimeOverviewKeyword } from '@op/services/realtime';

const namespace = 'opinionPerformance';

type stateType = {
  keyMetrics: any;
  region: any;
  language: any;
  channel: any;
  competitor: any;
};

const customModel: {
  effects: {
    [key: string]: Effect;
  };
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    keyMetrics: [],
    region: [],
    language: [],
    channel: [],
    competitor: [],
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { ...state, ...payload };
    },
  },
  effects: {
    *getOverviewKeyMetrics({ payload }, { put }) {
      try {
        const res: keyMetricsListType = yield getOverviewKeyMetrics({
          ...payload,
        });
        yield put({
          type: 'save',
          payload: {
            keyMetrics: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            keyMetrics: [],
          },
        });
      }
    },

    *getOverviewRegion({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewRegion({
          ...payload,
        });
        // console.log('region', res);
        yield put({
          type: 'save',
          payload: {
            region: transformGlobal(res),
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            region: [],
          },
        });
      }
    },

    *getOverviewCountry({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewCountry({
          ...payload,
        });
        // console.log('region', res);
        yield put({
          type: 'save',
          payload: {
            region: transformGlobal(res),
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            region: [],
          },
        });
      }
    },

    *getOverviewLanguage({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewLanguage({
          ...payload,
        });
        // console.log('language', res);
        yield put({
          type: 'save',
          payload: {
            language: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            language: [],
          },
        });
      }
    },

    *getOverviewChannel({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewChannel({
          ...payload,
        });
        // console.log('channel', res);
        yield put({
          type: 'save',
          payload: {
            channel: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            channel: [],
          },
        });
      }
    },

    *getOverviewVersionTimeline({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewVersionTimeline({
          ...payload,
        });
        yield put({
          type: 'save',
          payload: {
            version: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            version: [],
          },
        });
      }
    },

    *getOverviewKeyword({ payload, cancelCallback = () => { } }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewKeyword(
          {
            ...payload,
          },
          cancelCallback,
        );
        yield put({
          type: 'save',
          payload: {
            keyword: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            keyword: [],
          },
        });
      }
    },

    *getOverviewTopic({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewTopic({
          ...payload,
        });
        // console.log('channel', res);
        yield put({
          type: 'save',
          payload: {
            topic: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            topic: [],
          },
        });
      }
    },

    *getOverviewTopicTimeline({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewTopicTimeline({
          ...payload,
        });
        // console.log('channel', res);
        yield put({
          type: 'save',
          payload: {
            topicTimeline: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            topicTimeline: [],
          },
        });
      }
    },

    *getOverviewKeywordTimeline({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewKeywordTimeline({
          ...payload,
        });
        yield put({
          type: 'save',
          payload: {
            keywordTimeline: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            keywordTimeline: [],
          },
        });
      }
    },

    *getOverviewCompetitor({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewCompetitor({
          ...payload,
        });
        // console.log('channel', res);
        yield put({
          type: 'save',
          payload: {
            competitor: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            competitor: [],
          },
        });
      }
    },

    *getOverviewGameStore({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewGameStore({
          ...payload,
        });
        // console.log('game store', res);
        yield put({
          type: 'save',
          payload: {
            gameStore: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            topic: [],
          },
        });
      }
    },

    // *getOverviewMentionsSentiment({ payload }, { put }) {
    //   try {
    //     const res: overviewOriginType = yield getOverviewMentionsSentiment({
    //       ...payload,
    //     });
    //     // console.log('game store', res);
    //     yield put({
    //       type: 'save',
    //       payload: {
    //         mentionsSentiment: res,
    //       },
    //     });
    //   } catch {
    //     yield put({
    //       type: 'save',
    //       payload: {
    //         mentionsSentiment: [],
    //       },
    //     });
    //   }
    // },

    *getOverviewDauRevDls({ payload }, { put }) {
      const { metric } = payload;

      try {
        const res: overviewOriginType = yield getOverviewDauRevDls({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            [metric]: res?.[metric + '_trends_time']?.[0]?.history,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            [metric]: [],
          },
        });
      }
    },

    *getOverviewLifetimePcConsole({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewLifetimePcConsole({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            lifetimePcConsole: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            lifetimePcConsole: [],
          },
        });
      }
    },

    *getOverviewTimeline({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getOverviewTimeline({
          ...payload,
        });

        yield put({
          type: 'save',
          payload: {
            timeline: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            timeline: [],
          },
        });
      }
    },

    *getRealtimeLanguage({ payload }, { put }) {
      try {
        const res: overviewOriginType = yield getRealtimeLanguage({
          ...payload,
        });
        // console.log('language', res);
        yield put({
          type: 'save',
          payload: {
            language: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            language: [],
          },
        });
      }
    },

    *getRealtimeOverviewKeyword({ payload, cancelCallback = () => { } }, { put }) {
      try {
        const res: overviewOriginType = yield getRealtimeOverviewKeyword(
          {
            ...payload,
          },
          cancelCallback,
        );
        yield put({
          type: 'save',
          payload: {
            keyword: res,
          },
        });
      } catch {
        yield put({
          type: 'save',
          payload: {
            keyword: [],
          },
        });
      }
    },

  },
};

export default customModel;
